import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ModalTitle', null, { withChildren: true });
